<div class="box-dialog-wrapper">
  <box-dialog-header
    title="order_cost_calculation"
    class="box-dialog-header"
    (closeDialog)="closeDialog()"
  ></box-dialog-header>
  <main class="box-dialog-content">
    <section class="checkout-order-preview-info-dialog-section">
      <div *ngIf="showWeightedFeeInfo" class="checkout-order-preview-info-dialog-block ods-typography-body-s-regular">
        <span class="checkout-order-preview-info-dialog-block-title">{{ 'weighted_fee' | translate }}</span>
        <span class="checkout-order-preview-info-dialog-block-description">{{ weightedFeeText }}</span>
      </div>
      <div
        *ngIf="orderPriceCalculationInfo"
        class="checkout-order-preview-info-dialog-block ods-typography-body-s-regular"
      >
        <span class="checkout-order-preview-info-dialog-block-title">{{ orderPriceCalculationInfo.title }}</span>
        <span class="checkout-order-preview-info-dialog-block-description">
          {{ orderPriceCalculationInfo.description }}
        </span>
      </div>
      <div *ngIf="showEnvFeeInfo" class="checkout-order-preview-info-dialog-block ods-typography-body-s-regular">
        <span class="checkout-order-preview-info-dialog-block-title">{{ 'environmental_fee' | translate }}</span>
        <span class="checkout-order-preview-info-dialog-block-description">{{ envFeeText }}</span>
      </div>
      <div *ngIf="showDeliveryFeeInfo" class="checkout-order-preview-info-dialog-block ods-typography-body-s-regular">
        <span class="checkout-order-preview-info-dialog-block-title">{{ 'delivery_fee' | translate }}</span>
        <span class="checkout-order-preview-info-dialog-block-description">{{ deliveryFeeText }}</span>
      </div>
      <div *ngIf="showServiceFeeInfo" class="checkout-order-preview-info-dialog-block ods-typography-body-s-regular">
        <span class="checkout-order-preview-info-dialog-block-title">{{ 'service_fee' | translate }}</span>
        <span class="checkout-order-preview-info-dialog-block-description">{{ serviceFeeText }}</span>
      </div>
    </section>
  </main>
</div>
